import React, { useState } from 'react';
import PropTypes from 'prop-types';
import connect from '../utils/connect';

export const CreatePacingContext = React.createContext(null);

const CreatePacingProvider = ({ children }) => {
    const [areAllPlacementsSelected, setAreAllPlacementsSelected] = useState(
        true,
    );
    const [userActivities, setUserActivities] = useState([]);

    const providerValue = {
        areAllPlacementsSelected,
        userActivities,
        setAreAllPlacementsSelected,
        setUserActivities,
    };

    return (
        <CreatePacingContext.Provider value={providerValue}>
            {children}
        </CreatePacingContext.Provider>
    );
};

CreatePacingProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default connect(['filters'])(CreatePacingProvider);
